import { BlockContentConsumer } from '@/components/ContentStack/BlockContentConsumer'
import { useTranslations } from '@/hooks/useTranslations'

import type React from 'react'
import type { BlockContentComponent } from '@/gen/sanity/schema'

export const SanityBlockContent: React.FC<{
  sanityComponent: BlockContentComponent
}> = ({ sanityComponent }) => {
  const { language } = useTranslations()
  const sanityBlockContent = sanityComponent?.blockContent ? sanityComponent?.blockContent[language] : null

  return sanityBlockContent ? <BlockContentConsumer value={sanityBlockContent} /> : <></>
}
